export default __webpack_public_path__ + "static/media/logo.83a5c9d5.png";